
    window.onload = function () {
  // Check if required variables are defined (set by sales-bar section)
  if (typeof startDateStr === 'undefined' || typeof endDateStr === 'undefined' ||
      typeof startTimeStr === 'undefined' || typeof endTimeStr === 'undefined') {
    return; // Exit if sales bar is not on this page
  }

  // Get the current date and time
  var currentDate = new Date();
  // Parse the start and end date and time strings from the settings
  var startDate = new Date(startDateStr); // Use the variable name assigned in Liquid

  var endDate = new Date(endDateStr); // Use the variable name assigned in Liquid
  var startTime = new Date(startTimeStr); // Use the variable name assigned in Liquid
  var endTime = new Date(endTimeStr); // Use the variable name assigned in Liquid


  // Parse the date components
  var startDateParts = startDateStr.split('-');
  var endDateParts = endDateStr.split('-');

  // Parse the time components
  var startTimeParts = startTimeStr.split('-');
  var endTimeParts = endTimeStr.split('-');

  // Create Date objects for start and end dates
  var startDate = new Date(startDateParts[2], startDateParts[0] - 1, startDateParts[1]);
  var endDate = new Date(endDateParts[2], endDateParts[0] - 1, endDateParts[1]);

  // Create Date objects for start and end times
  var startTime = new Date(startDate);
  startTime.setHours(startTimeParts[0]);
  startTime.setMinutes(startTimeParts[1]);
  startTime.setSeconds(startTimeParts[2]);

  var endTime = new Date(endDate);
  endTime.setHours(endTimeParts[0]);
  endTime.setMinutes(endTimeParts[1]);
  endTime.setSeconds(endTimeParts[2]);

  // Get the sales bar element
  var salesBar = document.getElementById('sales-bar');
   // Initially hide the sales bar
  salesBar.style.display = 'none';
      


  // Update the countdown timer
  var countdownTimer = document.getElementById('js_set_time');

  function updateCountdown() {
    var now = new Date();

    if (now >= startDate && now <= endDate && now >= startTime && now <= endTime) {
      var timeRemaining = endTime - now;

      if (timeRemaining <= 0) {
        countdownTimer.style.display = 'none'; // Hide the countdown when the end date and time is reached
        return;
      }
      var days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
      var hours = Math.floor((timeRemaining / (1000 * 60 * 60)) % 24);
      var minutes = Math.floor((timeRemaining / (1000 * 60)) % 60);
      var seconds = Math.floor((timeRemaining / 1000) % 60);

       // Display "Days" or "Day" based on the number of days left
      var daysLabel = days == 1 ? 'day' : 'days';
      
      // Display "Hours" or "Hour" based on the number of hours left
      var hoursLabel = hours == 1 ? 'hr' : 'hrs';

       // Display "Hours" or "Hour" based on the number of hours left
      var minsLabel = hours == 1 ? 'min' : 'mins';

       // Display "Hours" or "Hour" based on the number of hours left
      var secLabel = hours == 1 ? 'sec' : 'secs';
      
      var daysElement = document.querySelector('.countdown_days');
      var hoursElement = document.querySelector('.countdown_hours');
      var minsElement = document.querySelector('.countdown_mins');
      var secElement = document.querySelector('.countdown_secs');
      // Update the content of the element
      daysElement.textContent = daysLabel;
      hoursElement.textContent = hoursLabel;
      minsElement.textContent = minsLabel;
      secElement.textContent = secLabel;
      
      
      document.querySelector('.js-days').textContent = days.toString().padStart(2, '0');
      document.querySelector('.js-hours').textContent = hours.toString().padStart(2, '0');
      document.querySelector('.js-minutes').textContent = minutes.toString().padStart(2, '0');
      document.querySelector('.js-seconds').textContent = seconds.toString().padStart(2, '0');
      countdownTimer.style.display = 'flex';
      var timeToShowSalesBar = 10 * 60 * 1000; // 10 minutes in milliseconds
   // Check if it's time to show the sales bar
      if (currentDate >= startDate && currentDate <= endDate && currentDate >= startTime && currentDate <= endTime) {
    // Show the sales bar because the current date and time is within the specified range
    salesBar.style.display = 'flex';
  }
    } else {
      countdownTimer.style.display = 'none';
    }
  }

  // Call the updateCountdown function initially
  updateCountdown();

  // Update the countdown every second
  setInterval(updateCountdown, 1000);

  // Function to update the progress bar
function updateProgressBar() {
  var now = new Date();

  // Calculate the elapsed time in milliseconds
  var timeElapsed = now - startTime;
  var totalTime = endTime - startTime;

  // Calculate the progress percentage
  var progress = (timeElapsed / totalTime) * 100;

  // Update the width of the progress bar
  document.querySelector('.progress-bar').style.width = progress + '%';

  if (progress >= 100) {
    // Hide the progress bar when the countdown is complete
    document.querySelector('.progress-bar').style.display = 'none';
  }
}

// Set the initial width of the progress bar to 0% when the page loads
document.querySelector('.progress-bar').style.width = '0%';

// Call the updateProgressBar function initially
updateProgressBar();
};
